import { asText, Content, isFilled } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import styles from 'components/PRISMIC/scss/pages.module.scss';
import cx from 'classnames';

import type { JSX } from 'react';

/**
 * Props for `PromoBox`.
 */
export type PromoBoxProps = SliceComponentProps<Content.PromoBoxSlice>;

/**
 * Component for "PromoBox" Slices.
 */
const PromoBox = ({ slice }: PromoBoxProps): JSX.Element => {
  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={cx(
        styles['pages-promo'],
        styles['pages-module'],
        styles.module,
        styles.inverse
      )}
    >
      {isFilled.richText(slice.primary.heading) && (
        <h2 className={cx(styles.h4, styles.m4)}>
          {asText(slice.primary.heading)}
        </h2>
      )}
      <strong>
        <PrismicRichText field={slice.primary.text} />
      </strong>
    </div>
  );
};

export default PromoBox;
